import { QueryParam } from './constants/queryParam';

export function openInNewTab(url: string) {
  return window.open(url, '_blank');
}

export function openPdfInNewTab(fileUrl: string) {
  const viewerUrl = `/pdf-viewer?${QueryParam.URL}=${encodeURIComponent(fileUrl)}`;
  return window.open(viewerUrl, '_blank', 'noopener,noreferrer');
}

export function isInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return false;
  }
}
